import {ListItemText, styled} from "@mui/material";

const StyledListItemText = styled((props) => <ListItemText {...props} />)(
  ({ theme }) => {
    return {
      "& .MuiTypography-root": {
        color: "inherit",
        fontWeight: "bold",
      },
    };
  }
);

export default StyledListItemText;
